import React from "react";
import { Breakdown } from "./Breakdown";
import { Stack } from "@bookingcom/bui-react";
import { Atol, HiddenFees, SIRF, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownPostBookingPaymentController,
  type UnifiedPriceBreakdownPostBookingPaymentControllerProps
} from "./useUnifiedPriceBreakdown.PostBookingPayment.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownPostBookingPaymentProps = UnifiedPriceBreakdownPostBookingPaymentControllerProps;

export function UnifiedPriceBreakdownPostBookingPayment(props: UnifiedPriceBreakdownPostBookingPaymentProps) {
  const {
    unifiedPriceBreakdown,
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    addedItems,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownPostBookingPaymentController(props);

  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "PostBookingPayment", routeName });
    return null;
  }

  return (
    <Stack>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        addedItems={addedItems}
        isWithDiscount={isWithDiscount} // flights_unified_price_breakdown_pb
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <SIRF />
      <HiddenFees />
    </Stack>
  );
}
